import { useEffect, useState } from "react";
import { initialText, initialTextUrl } from "./InitialText.js";

const STORAGE_KEY = "md2pdf.markdown";
const STORAGE_DEBOUNCE_MS = 400;

const readStoredText = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

const useText = (initialValue = initialText) => {
  const [state, setState] = useState(() => {
    const storedText = readStoredText();
    return storedText === null ? initialValue : storedText;
  });

  useEffect(() => {
    if (readStoredText() !== null) return undefined;
    let disposed = false;
    fetch(initialTextUrl)
      .then(response => {
        if (!response.ok) throw new Error(`Failed to load ${initialTextUrl}`);
        return response.text();
      })
      .then(content => {
        if (disposed) return;
        setState(current => (current === initialValue ? content : current));
      })
      .catch(() => {
        // The inline fallback remains available when the static example is unavailable.
      });
    return () => {
      disposed = true;
    };
  }, [initialValue]);

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        window.localStorage.setItem(STORAGE_KEY, state);
      } catch (error) {
        // Local storage may be unavailable or full; editing still works in memory.
      }
    }, STORAGE_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [state]);

  return [state, setState];
};
export default useText;
